(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vyfinity-arctic-wolf-landing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.aw').forEach((root) => {
      const bar = root.querySelector('[data-aw-sticky]');
      const hero = root.querySelector('.aw-hero');
      const buy = root.querySelector('.aw-buy');
      if (!bar || !hero || !buy || !('IntersectionObserver' in window)) return;

      const state = { hero: true, buy: false };
      const update = () => bar.classList.toggle('is-visible', !state.hero && !state.buy);
      new IntersectionObserver(([e]) => { state.hero = e.isIntersecting; update(); }).observe(hero);
      new IntersectionObserver(([e]) => { state.buy = e.isIntersecting; update(); }).observe(buy);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vyfinity-control-noise-landing"] && !Shopify.designMode) return;
  try {
    
(() => {
  const setupReveal = root => {
    const items = Array.from(root.querySelectorAll('.vca__reveal'));
    if (!items.length) return;
    const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!('IntersectionObserver' in window) || reduceMotion) {
      items.forEach(el => el.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); obs.unobserve(entry.target); }
      });
    }, { threshold: 0.16, rootMargin: '0px 0px -8% 0px' });
    items.forEach(el => observer.observe(el));
  };
  const setupStickyBar = root => {
    const bar = root.querySelector('[data-sticky-bar]');
    const productBlock = root.querySelector('.vca__product');
    if (!bar || !productBlock || !('IntersectionObserver' in window)) return;
    const finalBlock = root.querySelector('.vca__final');
    bar.hidden = false;
    let show = false;
    const apply = () => bar.classList.toggle('is-visible', show);
    new IntersectionObserver(entries => {
      entries.forEach(entry => {
        show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        apply();
      });
    }, { threshold: 0 }).observe(productBlock);
    if (finalBlock) {
      new IntersectionObserver(entries => {
        entries.forEach(entry => { if (entry.isIntersecting) { show = false; apply(); } });
      }, { threshold: 0 }).observe(finalBlock);
    }
  };
  const init = root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    root.classList.add('vca--js');
    setupReveal(root);
    const json = root.querySelector('[data-cn-product]');
    const select = root.querySelector('[data-variant-select]');
    if (!json || !select) return;
    let product;
    try { product = JSON.parse(json.textContent); } catch { return; }
    const variants = product.variants || [];
    let current = variants.find(v => String(v.id) === select.value) || variants[0];
    if (!current) return;
    const options = product.options.map(o => typeof o === 'string' ? o : o.name);
    const colorIndex = options.findIndex(n => /color|colour|farbe/i.test(n));
    const container = root.querySelector('[data-options]');
    const image = root.querySelector('[data-product-image]');
    const submit = root.querySelector('[data-add-button]');
    const status = root.querySelector('[data-status]');
    const controls = root.querySelector('[data-view-controls]');
    const back = controls.querySelector('[data-view="back"]');
    const backTokens = {Black:['schwarz_back','215gsm-5.png'],Anthracite:['anthrazit_back'],'Blue Ice':['blue_ice_back'],'Bubble-Pink':['bubble_pink_back'],'French-Navy':['navy_back'],'Glazed-Green':['glazed_green_back'],Khaki:['kaki_back'],'Pool Blue':['pool_blue_back'],White:['weiss_back','215gsm-11.png']};
    const backMap = Object.fromEntries(Object.entries(backTokens).map(([color,tokens]) => [color,(product.images || []).map(i=>typeof i === 'string' ? i : i.src).find(src=>src && tokens.some(token=>src.toLowerCase().includes(token))) || '']));
    const swatches = {black:'#151515',anthracite:'#3a3b3d','anthrazit':'#3a3b3d','blue ice':'#d3e8f2','blue-ice':'#d3e8f2','bubble-pink':'#e8629f','bubble pink':'#e8629f','french-navy':'#1c222e','french navy':'#1c222e','glazed-green':'#133835','glazed green':'#133835',khaki:'#424436','pool blue':'#5fa8c9','pool-blue':'#5fa8c9',white:'#f5f3f0'};
    const dialog = root.querySelector('[data-zoom-dialog]');
    const zoom = root.querySelector('[data-zoom]');
    if (dialog && zoom) {
      zoom.addEventListener('click', () => { const large = dialog.querySelector('[data-zoom-image]');const palette = getComputedStyle(image);['--cn-bg','--cn-ink','--cn-line'].forEach(key => dialog.style.setProperty(key,palette.getPropertyValue(key)));large.src = image.src;large.alt = image.alt;dialog.showModal(); });
      dialog.querySelector('[data-zoom-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', e => {if(e.target === dialog) dialog.close();});
      dialog.addEventListener('close', () => zoom.focus());
    }
    const choices = [];
    options.forEach((name, index) => {
      const field = document.createElement('fieldset');
      const legend = document.createElement('legend');
      legend.textContent = /color|colour|farbe/i.test(name) ? root.dataset.colorLabel : /size|größe|groesse/i.test(name) ? root.dataset.sizeLabel : name;
      const chosen = document.createElement('span');chosen.className = 'vca__chosen';chosen.dataset.chosen = index;legend.append(chosen);field.append(legend);
      const list = document.createElement('div'); list.className = 'vca__choices';
      [...new Set(variants.map(v => v.options[index]))].forEach((value, n) => {
        const wrap = document.createElement('div'); wrap.className = 'vca__choice' + (index === colorIndex ? ' vca__choice--color' : '');
        const input = document.createElement('input'); input.type = 'radio'; input.name = root.id + '-option-' + index; input.id = input.name + '-' + n; input.value = value; input.dataset.option = index; input.checked = current.options[index] === value;
        const label = document.createElement('label'); label.htmlFor = input.id;
        if (index === colorIndex && swatches[value.toLowerCase()]) { const dot = document.createElement('span'); dot.className = 'vca__swatch'; dot.style.setProperty('--swatch', swatches[value.toLowerCase()]); dot.setAttribute('aria-hidden','true'); label.append(dot); }
        const nameText = document.createElement('span');nameText.textContent = value;if(index === colorIndex) nameText.className = 'vca__sr';label.title = value;label.append(nameText);wrap.append(input,label);list.append(wrap);choices.push(input);
      });
      field.append(list);container.append(field);
    });
    root.querySelector('[data-native-picker]').hidden = true;
    controls.hidden = false;
    let view = 'front';
    const priceFormat = new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {style:'currency',currency:root.dataset.currency || 'EUR'});
    const showImage = () => {
      const backSrc = colorIndex >= 0 ? backMap[current.options[colorIndex]] : '';
      back.hidden = !backSrc;
      if (!backSrc) view = 'front';
      const src = view === 'back' ? backSrc : current.featured_image?.src || product.featured_image;
      if (src) { image.src = src.startsWith('//') ? 'https:' + src : src; image.alt = product.title + ' — ' + current.title + ' — ' + (view === 'back' ? root.dataset.backLabel : root.dataset.frontLabel); }
      controls.querySelectorAll('button').forEach(b => b.setAttribute('aria-pressed',String(b.dataset.view === view)));
      root.querySelector('[data-image-caption]').textContent = current.title + ' / ' + (view === 'back' ? root.dataset.backLabel : root.dataset.frontLabel);
    };
    const update = () => {
      select.value = String(current.id); select.disabled = false;
      container.querySelectorAll('[data-chosen]').forEach(el => {el.textContent = current.options[Number(el.dataset.chosen)];});
      choices.forEach(input => {
        const index = Number(input.dataset.option);
        input.checked = current.options[index] === input.value;
        input.closest('.vca__choice').hidden = index !== colorIndex && !variants.some(v => v.options[index] === input.value && v.options.every((x,i) => i === index || x === current.options[i]));
        input.disabled = !variants.some(v => v.available && v.options[index] === input.value && (index === colorIndex || v.options.every((x,i) => i === index || x === current.options[i])));
      });
      root.querySelector('[data-price]').textContent = priceFormat.format(current.price/100);
      submit.disabled = !current.available;
      submit.textContent = current.available ? root.dataset.add : root.dataset.sold;
      status.textContent = current.available ? '' : root.dataset.sold;
      const stickyPrice = root.querySelector('[data-sticky-price]');
      const stickyAdd = root.querySelector('[data-sticky-add]');
      if (stickyPrice) stickyPrice.textContent = priceFormat.format(current.price/100);
      if (stickyAdd) { stickyAdd.disabled = !current.available; stickyAdd.textContent = current.available ? root.dataset.add : root.dataset.sold; }
      view = 'front';showImage();
    };
    container.addEventListener('change',event => {
      const input = event.target.closest('input[data-option]'); if (!input) return;
      const index = Number(input.dataset.option);
      const requested = [...current.options];requested[index] = input.value;
      const exact = variants.find(v => v.available && v.options.every((x,i) => x === requested[i]));
      const fallback = variants.find(v => v.available && v.options[index] === input.value);
      const next = exact || fallback;
      if (!next) { submit.disabled = true;select.disabled = true;status.textContent = root.dataset.unavailable;return; }
      const changedSize = !exact; current = next;update();
      if (changedSize) status.textContent = current.title;
    });
    controls.addEventListener('click',event => {const button = event.target.closest('[data-view]');if (!button || button.hidden) return;view = button.dataset.view;showImage();});
    select.form.addEventListener('submit', event => {
      const form = event.target;
      if (form.dataset.cnFallback === 'true') return; // Fallback-Resubmit: natives Verhalten zulassen, keine Endlosschleife
      if (submit.disabled || select.disabled || !current.available || select.value !== String(current.id)) {
        event.preventDefault();
        status.textContent = root.dataset.unavailable;
        return;
      }
      if (typeof window.fetch !== 'function') return; // kein fetch verfügbar: natives Formular-Submit zulassen
      event.preventDefault();
      const stickyAdd = root.querySelector('[data-sticky-add]');
      const restLabel = current.available ? root.dataset.add : root.dataset.sold;
      const setBoth = (text, disabled) => {
        submit.textContent = text; submit.disabled = disabled;
        if (stickyAdd) { stickyAdd.textContent = text; stickyAdd.disabled = disabled; }
      };
      const setClassBoth = (cls, on) => {
        submit.classList.toggle(cls, on);
        if (stickyAdd) stickyAdd.classList.toggle(cls, on);
      };
      setClassBoth('is-success', false); setClassBoth('is-error', false);
      setClassBoth('is-loading', true);
      setBoth(root.dataset.adding, true);
      status.textContent = '';
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
        .then(res => res.json().then(data => ({ ok: res.ok, data })))
        .then(({ ok, data }) => {
          setClassBoth('is-loading', false);
          if (!ok) {
            setBoth(restLabel, false);
            setClassBoth('is-error', true);
            status.textContent = (data && data.description) || root.dataset.error;
            setTimeout(() => setClassBoth('is-error', false), 2600);
            return;
          }
          setClassBoth('is-success', true);
          setBoth(root.dataset.added, true);
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: data, bubbles: true }));
          setTimeout(() => {
            setClassBoth('is-success', false);
            setBoth(current.available ? root.dataset.add : root.dataset.sold, !current.available);
          }, 1800);
        })
        .catch(() => {
          setClassBoth('is-loading', false);
          form.dataset.cnFallback = 'true';
          if (form.requestSubmit) form.requestSubmit(submit); else form.submit();
        });
    });
    update();
    setupStickyBar(root);
  };
  const scan = scope => {if (scope.matches?.('[data-cn-atelier]')) init(scope);scope.querySelectorAll('[data-cn-atelier]').forEach(init);};
  scan(document);
  document.addEventListener('shopify:section:load',event => scan(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vyfinity-inner-worlds-landing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = root => {
      if (!root || root.dataset.vyReady === 'true') return;
      root.dataset.vyReady = 'true';

      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const colorIndex = Number(root.dataset.colorPosition) - 1;
      const sizeIndex = Number(root.dataset.sizePosition) - 1;
      let view = root.dataset.initialView || 'front';
      let variant = variants.find(item => String(item.id) === root.querySelector('[data-variant-id]')?.value) || variants[0];

      const selectedOptions = () => {
        const selected = [...(variant?.options || variants[0]?.options || [])];
        root.querySelectorAll('[data-option-input]:checked').forEach(input => {
          selected[Number(input.dataset.optionPosition) - 1] = input.value;
        });
        return selected;
      };

      const updateVariant = nextVariant => {
        variant = nextVariant || null;
        const variantInput = root.querySelector('[data-variant-id]');
        if (variantInput) variantInput.value = variant ? String(variant.id) : '';
        root.querySelectorAll('[data-product-submit]').forEach(button => {
          button.disabled = !variant?.available;
          button.textContent = variant?.available ? button.dataset.availableLabel : root.dataset.soldOutText;
        });
        if (!variant) return;
        const price = new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
          style: 'currency',
          currency: root.dataset.currency || 'EUR'
        }).format(variant.price / 100);
        root.querySelectorAll('[data-product-price],[data-mobile-price]').forEach(element => {
          element.textContent = price;
        });
        const colorLabel = root.querySelector('[data-selected-color]');
        if (colorLabel) colorLabel.textContent = variant.options[colorIndex];
      };

      const updateAvailability = () => {
        const selected = selectedOptions();
        root.querySelectorAll('[data-option-input]').forEach(input => {
          const index = Number(input.dataset.optionPosition) - 1;
          if (index !== sizeIndex) return;
          input.disabled = !variants.some(item =>
            item.available &&
            item.options[sizeIndex] === input.value &&
            item.options[colorIndex] === selected[colorIndex]
          );
        });
      };

      const updateImage = () => {
        const image = root.querySelector('[data-product-image]');
        if (!image) return;
        const color = selectedOptions()[colorIndex];
        const map = Array.from(root.querySelectorAll('[data-color-map]')).find(item => item.dataset.value === color);
        const fallback = root.querySelector('[data-default-map]');
        const sourceVariant = variant || variants.find(item => item.options[colorIndex] === color);
        const front = map?.dataset.front || sourceVariant?.featured_image?.src || fallback?.dataset.front;
        const back = map?.dataset.back;

        if (view === 'back' && !back) view = 'front';
        const backButton = root.querySelector('[data-view="back"]');
        if (backButton) backButton.hidden = !back;
        const source = view === 'back' ? back : front;

        root.dataset.productView = view;
        root.querySelectorAll('[data-view]').forEach(button => {
          const active = button.dataset.view === view;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });
        const index = root.querySelector('[data-image-index]');
        if (index) index.textContent = (view === 'front' ? '01' : '02') + ' / ' + (back ? '02' : '01');
        if (!source) return;
        const widths = [600, 900, 1200, 1500];
        const buildSrc = width => {
          const variantUrl = new URL(source, location.href);
          variantUrl.searchParams.set('width', String(width));
          return variantUrl.href;
        };
        image.src = buildSrc(1500);
        image.srcset = widths.map(width => buildSrc(width) + ' ' + width + 'w').join(', ');
        image.sizes = '(max-width: 900px) 100vw, 50vw';
        image.alt = (
          view === 'back'
            ? map?.dataset.backAlt
            : map?.dataset.frontAlt || sourceVariant?.featured_image?.alt
        ) || ((root.querySelector('.vy-iw__product-panel h2')?.textContent || '') + ' — ' + color);
      };

      const chooseVariant = target => {
        const selected = selectedOptions();
        let nextVariant = variants.find(item => item.options.every((value, index) => value === selected[index]));
        if (Number(target.dataset.optionPosition) - 1 === colorIndex && (!nextVariant || !nextVariant.available)) {
          nextVariant = variants.find(item => item.options[colorIndex] === selected[colorIndex] && item.available)
            || variants.find(item => item.options[colorIndex] === selected[colorIndex]);
          if (nextVariant) {
            root.querySelectorAll('[data-option-input]').forEach(input => {
              input.checked = input.value === nextVariant.options[Number(input.dataset.optionPosition) - 1];
            });
          }
        }
        updateVariant(nextVariant);
        updateAvailability();
        updateImage();
      };

      root.addEventListener('change', event => {
        if (event.target.matches('[data-option-input]')) chooseVariant(event.target);
      });
      root.addEventListener('click', event => {
        const button = event.target.closest('[data-view]');
        if (!button || !root.contains(button)) return;
        event.preventDefault();
        view = button.dataset.view;
        updateImage();
      });
      root.querySelector('.vy-iw__form')?.addEventListener('submit', event => {
        if (!variant?.available) event.preventDefault();
      });

      root.classList.add('is-enhanced', 'vy-iw--in');
      updateAvailability();
      updateImage();

      const targets = root.querySelectorAll('.vy-iw__reveal,.vy-iw__parallax');
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!('IntersectionObserver' in window) || reduced || !root.hasAttribute('data-scroll-reveal')) {
        targets.forEach(target => target.classList.add('is-visible'));
      } else {
        const revealObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          });
        }, { threshold: .08 });
        targets.forEach(target => revealObserver.observe(target));
      }

      const bar = root.querySelector('.vy-iw__mobile-bar');
      const hero = root.querySelector('.vy-iw__hero');
      const form = root.querySelector('.vy-iw__form');
      if (bar && hero && form && 'IntersectionObserver' in window) {
        let heroPassed = false;
        let formVisible = false;
        let sectionVisible = true;
        const barObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.target === hero) heroPassed = entry.boundingClientRect.bottom <= 0;
            if (entry.target === form) formVisible = entry.isIntersecting;
            if (entry.target === root) sectionVisible = entry.isIntersecting;
          });
          bar.classList.toggle('is-visible', heroPassed && !formVisible && sectionVisible);
        }, { threshold: 0 });
        [hero, form, root].forEach(element => barObserver.observe(element));
      }
    };

    document.querySelectorAll('vy-inner-worlds').forEach(init);
    document.addEventListener('shopify:section:load', event => {
      event.target.querySelectorAll('vy-inner-worlds').forEach(init);
    });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vyfinity-last-doll-landing"] && !Shopify.designMode) return;
  try {
    
  function initVyLastDoll(root) {
    if (!root || root.dataset.vyReady === 'true') return;
    root.dataset.vyReady = 'true';

    function setAudience(audience, shouldScroll) {
      root.querySelectorAll('[data-vy-audience]').forEach(function(panel) {
        panel.classList.toggle('is-active', panel.dataset.vyAudience === audience);
      });
      root.querySelectorAll('[data-vy-audience-target]').forEach(function(button) {
        var active = button.dataset.vyAudienceTarget === audience;
        if (button.getAttribute('role') === 'tab') {
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-selected', active ? 'true' : 'false');
        }
      });
      if (shouldScroll) {
        var products = root.querySelector('.vy-ld__collection');
        if (products) products.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    root.addEventListener('click', function(event) {
      var audienceButton = event.target.closest('[data-vy-audience-target]');
      if (audienceButton && root.contains(audienceButton)) {
        event.preventDefault();
        setAudience(audienceButton.dataset.vyAudienceTarget, audienceButton.hasAttribute('data-vy-scroll'));
        return;
      }

      var viewButton = event.target.closest('[data-vy-view-target]');
      if (!viewButton || !root.contains(viewButton)) return;
      var panel = viewButton.closest('[data-vy-audience]');
      if (!panel) return;
      var view = viewButton.dataset.vyViewTarget;
      panel.querySelectorAll('[data-vy-view-target]').forEach(function(button) {
        var active = button.dataset.vyViewTarget === view;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      panel.querySelectorAll('[data-vy-view]').forEach(function(picture) {
        var active = picture.dataset.vyView === view;
        picture.hidden = !active;
        picture.classList.toggle('is-active', active);
      });
      var count = panel.querySelector('[data-vy-image-count]');
      if (count) count.textContent = view === 'front' ? count.dataset.frontCount : count.dataset.backCount;
    });
  }

  document.querySelectorAll('[data-vy-last-doll]').forEach(initVyLastDoll);
  document.addEventListener('shopify:section:load', function(event) {
    initVyLastDoll(event.target.querySelector('[data-vy-last-doll]'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vyfinity-last-doll-landing2"] && !Shopify.designMode) return;
  try {
    
  function initVyLastDoll(root) {
    if (!root || root.dataset.vyReady === 'true') return;
    root.dataset.vyReady = 'true';

    function setAudience(audience, shouldScroll) {
      root.querySelectorAll('[data-vy-audience]').forEach(function(panel) {
        panel.classList.toggle('is-active', panel.dataset.vyAudience === audience);
      });
      root.querySelectorAll('[data-vy-audience-target]').forEach(function(button) {
        var active = button.dataset.vyAudienceTarget === audience;
        if (button.getAttribute('role') === 'tab') {
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-selected', active ? 'true' : 'false');
        }
      });
      if (shouldScroll) {
        var products = root.querySelector('.vy-ld__collection');
        if (products) products.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    root.addEventListener('click', function(event) {
      var audienceButton = event.target.closest('[data-vy-audience-target]');
      if (audienceButton && root.contains(audienceButton)) {
        event.preventDefault();
        setAudience(audienceButton.dataset.vyAudienceTarget, audienceButton.hasAttribute('data-vy-scroll'));
        return;
      }

      var viewButton = event.target.closest('[data-vy-view-target]');
      if (!viewButton || !root.contains(viewButton)) return;
      var panel = viewButton.closest('[data-vy-audience]');
      if (!panel) return;
      var view = viewButton.dataset.vyViewTarget;
      panel.querySelectorAll('[data-vy-view-target]').forEach(function(button) {
        var active = button.dataset.vyViewTarget === view;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      panel.querySelectorAll('[data-vy-view]').forEach(function(picture) {
        var active = picture.dataset.vyView === view;
        picture.hidden = !active;
        picture.classList.toggle('is-active', active);
      });
      var count = panel.querySelector('[data-vy-image-count]');
      if (count) count.textContent = view === 'front' ? count.dataset.frontCount : count.dataset.backCount;
    });
  }

  document.querySelectorAll('[data-vy-last-doll]').forEach(initVyLastDoll);
  document.addEventListener('shopify:section:load', function(event) {
    initVyLastDoll(event.target.querySelector('[data-vy-last-doll]'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vyfinity-private-frequency-landing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.vyReady === 'true') return;
      root.dataset.vyReady = 'true';
      let activeColor = root.querySelector('[data-vy-color-target]')?.dataset.vyColorTarget || '';
      let activeView = 'front';
      const pictures = Array.from(root.querySelectorAll('[data-vy-color][data-vy-view]'));
      const viewButtons = Array.from(root.querySelectorAll('[data-vy-view-target]'));
      const colorButtons = Array.from(root.querySelectorAll('[data-vy-color-target]'));
      const count = root.querySelector('[data-vy-image-count]');
      const colorName = root.querySelector('[data-vy-selected-color]');
      const variantSelect = root.querySelector('.vy-pf__form select[name="id"]');
      const normalize = (value) => String(value || '').trim().toLowerCase().replace(/[\s_-]+/g, ' ');
      const variants = variantSelect ? Array.from(variantSelect.options) : [];
      const valuesOf = (option) => JSON.parse(option.dataset.vyOptions || '[]').map(normalize);
      const colorValue = (button) => {
        const name = normalize(button.dataset.vyColorName);
        const mapped = normalize(button.dataset.vyVariantValue);
        return variants.some((option) => valuesOf(option).includes(name)) ? name : mapped || name;
      };
      const syncVariant = () => {
        const option = variantSelect?.selectedOptions[0];
        if (!option) return;
        const values = valuesOf(option);
        const matchingButton = colorButtons.find((button) => values.includes(colorValue(button)));
        if (matchingButton) activeColor = matchingButton.dataset.vyColorTarget;
        const price = root.querySelector('.vy-pf__price');
        if (price) price.textContent = option.dataset.vyPrice || '';
        const submit = root.querySelector('.vy-pf__add');
        if (submit) submit.disabled = option.disabled;
      };

      const render = () => {
        pictures.forEach((picture) => {
          const visible = picture.dataset.vyColor === activeColor && picture.dataset.vyView === activeView;
          picture.hidden = !visible;
          picture.classList.toggle('is-active', visible);
        });
        viewButtons.forEach((button) => {
          const active = button.dataset.vyViewTarget === activeView;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-selected', String(active));
        });
        colorButtons.forEach((button) => {
          const active = button.dataset.vyColorTarget === activeColor;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
          if (active && colorName) colorName.textContent = button.dataset.vyColorName || '';
        });
        if (count) count.textContent = activeView === 'front' ? count.dataset.frontCount : count.dataset.backCount;
      };

      viewButtons.forEach((button) => button.addEventListener('click', () => {
        activeView = button.dataset.vyViewTarget;
        render();
      }));

      colorButtons.forEach((button) => button.addEventListener('click', () => {
        activeColor = button.dataset.vyColorTarget;
        const wanted = colorValue(button);
        if (variantSelect && wanted) {
          const current = variantSelect.selectedOptions[0];
          const previousValues = current ? valuesOf(current) : [];
          const candidates = variants.filter((option) => valuesOf(option).includes(wanted));
          const sameSize = (option) => valuesOf(option).every((value, index) => value === wanted || value === previousValues[index]);
          const match = candidates.find((option) => !option.disabled && sameSize(option))
            || candidates.find((option) => !option.disabled) || candidates[0];
          if (match) {
            variantSelect.value = match.value;
            variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        render();
      }));

      if (variantSelect) {
        variantSelect.addEventListener('change', () => {
          syncVariant();
          render();
        });
      }

      syncVariant();
      render();
    };

    document.querySelectorAll('[data-vy-private-frequency]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-vy-private-frequency]').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vyfinity-quiet-ones-know-landing"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vy-white-noise')) {
    customElements.define('vy-white-noise', class extends HTMLElement {
      connectedCallback() {
        this.view = this.dataset.initialView || 'back';
        this.dataset.productView = this.view;
        this.image = this.querySelector('[data-product-image]');
        this.variantInput = this.querySelector('[data-variant-id]');
        this.price = this.querySelector('[data-product-price]');
        this.mobilePrice = this.querySelector('[data-mobile-price]');
        this.submit = this.querySelector('[data-product-submit]');
        this.index = this.querySelector('[data-image-index]');
        this.heroImage = this.querySelector('[data-hero-image]');
        const variantData = this.querySelector('[data-product-variants]');
        this.variants = variantData ? JSON.parse(variantData.textContent) : [];
        this.addEventListener('change', this.onOptionChange.bind(this));
        this.querySelectorAll('[data-view]').forEach((button) => {
          button.addEventListener('click', () => this.setView(button.dataset.view));
        });
      }

      setView(view) {
        this.view = view;
        this.dataset.productView = view;
        this.querySelectorAll('[data-view]').forEach((button) => button.classList.toggle('is-active', button.dataset.view === view));
        if (this.index) this.index.textContent = view === 'front' ? '01 / 02' : '02 / 02';
        this.updateImage();
      }

      onOptionChange(event) {
        if (!event.target.matches('[data-option-input]')) return;
        const selected = [];
        this.querySelectorAll('[data-option-input]:checked').forEach((input) => {
          selected[Number(input.dataset.optionPosition) - 1] = input.value;
        });
        const variant = this.variants.find((item) => item.options.every((value, index) => selected[index] === value));
        if (variant) this.updateVariant(variant);
        const colorInput = this.querySelector(`[data-option-position="${this.dataset.colorPosition}"]:checked`);
        const colorLabel = this.querySelector('[data-selected-color]');
        if (colorInput && colorLabel) colorLabel.textContent = colorInput.value;
        this.updateImage();
      }

      updateVariant(variant) {
        if (this.variantInput) this.variantInput.value = variant.id;
        const formatted = new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
          style: 'currency', currency: this.dataset.currency || 'EUR'
        }).format(variant.price / 100);
        if (this.price) this.price.textContent = formatted;
        if (this.mobilePrice) this.mobilePrice.textContent = formatted;
        if (this.submit) {
          this.submit.disabled = !variant.available;
          this.submit.textContent = variant.available ? this.submit.dataset.availableLabel : this.dataset.soldOutText;
        }
      }

      updateImage() {
        if (!this.image) return;
        const checkedColor = this.querySelector(`[data-option-position="${this.dataset.colorPosition}"]:checked`);
        const map = checkedColor
          ? Array.from(this.querySelectorAll('[data-color-map]')).find((item) => item.dataset.value === checkedColor.value)
          : null;
        const fallback = this.querySelector('[data-default-map]');
        const source = (map && map.dataset[this.view]) || (fallback && fallback.dataset[this.view]);
        if (source) {
          this.image.removeAttribute('srcset');
          this.image.removeAttribute('sizes');
          this.image.src = source;
        }
        if (this.heroImage) {
          const heroSource = (map && map.dataset.hero) || (map && map.dataset.back) || (map && map.dataset.front);
          if (heroSource) {
            this.heroImage.removeAttribute('srcset');
            this.heroImage.removeAttribute('sizes');
            this.heroImage.src = heroSource;
          }
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vyfinity-startseite"] && !Shopify.designMode) return;
  try {
    

(() => {

  const roots = document.querySelectorAll('.vyf-home');

  roots.forEach((root) => {

    if (root.dataset.vyfReady === 'true') return;

    root.dataset.vyfReady = 'true';

  });

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vyfinity-white-noise-landing"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vy-white-noise')) {
    customElements.define('vy-white-noise', class extends HTMLElement {
      connectedCallback() {
        this.view = this.dataset.initialView || 'back';
        this.dataset.productView = this.view;
        this.image = this.querySelector('[data-product-image]');
        this.variantInput = this.querySelector('[data-variant-id]');
        this.price = this.querySelector('[data-product-price]');
        this.mobilePrice = this.querySelector('[data-mobile-price]');
        this.submit = this.querySelector('[data-product-submit]');
        this.index = this.querySelector('[data-image-index]');
        const variantData = this.querySelector('[data-product-variants]');
        this.variants = variantData ? JSON.parse(variantData.textContent) : [];
        this.addEventListener('change', this.onOptionChange.bind(this));
        this.querySelectorAll('[data-view]').forEach((button) => {
          button.addEventListener('click', () => this.setView(button.dataset.view));
        });
      }

      setView(view) {
        this.view = view;
        this.dataset.productView = view;
        this.querySelectorAll('[data-view]').forEach((button) => button.classList.toggle('is-active', button.dataset.view === view));
        if (this.index) this.index.textContent = view === 'front' ? '01 / 02' : '02 / 02';
        this.updateImage();
      }

      onOptionChange(event) {
        if (!event.target.matches('[data-option-input]')) return;
        const selected = [];
        this.querySelectorAll('[data-option-input]:checked').forEach((input) => {
          selected[Number(input.dataset.optionPosition) - 1] = input.value;
        });
        const variant = this.variants.find((item) => item.options.every((value, index) => selected[index] === value));
        if (variant) this.updateVariant(variant);
        const colorInput = this.querySelector(`[data-option-position="${this.dataset.colorPosition}"]:checked`);
        const colorLabel = this.querySelector('[data-selected-color]');
        if (colorInput && colorLabel) colorLabel.textContent = colorInput.value;
        this.updateImage();
      }

      updateVariant(variant) {
        if (this.variantInput) this.variantInput.value = variant.id;
        const formatted = new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
          style: 'currency', currency: this.dataset.currency || 'EUR'
        }).format(variant.price / 100);
        if (this.price) this.price.textContent = formatted;
        if (this.mobilePrice) this.mobilePrice.textContent = formatted;
        if (this.submit) {
          this.submit.disabled = !variant.available;
          this.submit.textContent = variant.available ? this.submit.dataset.availableLabel : this.dataset.soldOutText;
        }
      }

      updateImage() {
        if (!this.image) return;
        const checkedColor = this.querySelector(`[data-option-position="${this.dataset.colorPosition}"]:checked`);
        const map = checkedColor
          ? Array.from(this.querySelectorAll('[data-color-map]')).find((item) => item.dataset.value === checkedColor.value)
          : null;
        const fallback = this.querySelector('[data-default-map]');
        const source = (map && map.dataset[this.view]) || (fallback && fallback.dataset[this.view]);
        if (source) {
          this.image.removeAttribute('srcset');
          this.image.removeAttribute('sizes');
          this.image.src = source;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
